__turbopack_context__.v({
  "error": "ConfirmDomainDialog-module__T1DpwW__error",
  "hint": "ConfirmDomainDialog-module__T1DpwW__hint",
  "intro": "ConfirmDomainDialog-module__T1DpwW__intro",
});
